/* eslint-disable */
export default {
  init() {

    function new_map($el) {
      var styledMapType = new google.maps.StyledMapType(
        [{
          "elementType": "geometry",
          "stylers": [{
            "color": "#535353"
          }]
        }, {
          "elementType": "labels.icon",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#272727"
          }]
        }, {
          "elementType": "labels.text.stroke",
          "stylers": [{
            "color": "#595959"
          }]
        }, {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#bdbdbd"
          }]
        }, {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [{
            "color": "#4e4e4e"
          }]
        }, {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#343434"
          }]
        }, {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [{
            "color": "#4e4e4e"
          }]
        }, {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#9e9e9e"
          }]
        }, {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [{
            "color": "#595959"
          }]
        }, {
          "featureType": "road.arterial",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#3b3b3b"
          }]
        }, {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [{
            "color": "#4c4c4c"
          }]
        }, {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#3b3b3b"
          }]
        }, {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#3b3b3b"
          }]
        }, {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [{
            "color": "#4e4e4e"
          }]
        }, {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [{
            "color": "#eeeeee"
          }]
        }, {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [{
            "color": "#484848"
          }]
        }, {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#9e9e9e"
          }]
        }],
      {name: 'Styled Map'});

      var $markers = $el.find('.marker');
      var args = {
        zoom: 16,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        draggable: true,
        mapTypeControl: false,
        navigationControl: false,
        scaleControl: false,
        scrollwheel: false,
        zoomControl: false,
        mapTypeControlOptions: {
          mapTypeIds: ['styled_map']
        }
      };
      var map = new google.maps.Map($el[0], args);

      map.markers = [];
      $markers.each(function () {
        add_marker($(this), map);
      });

      map.mapTypes.set('styled_map', styledMapType);
      map.setMapTypeId('styled_map');

      center_map(map);
      return map;
    }

    function add_marker($marker, map) {
      var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
      var marker = new google.maps.Marker({
        position: latlng,
        label: {text: 'Raadhuisplein 4', fontWeight: "600", color: "#000" },
        map: map,
        icon: {url: $marker.attr('data-img'), labelOrigin: new google.maps.Point(82, 52)}
      });

      map.markers.push(marker);
      if ($marker.html()) {
        var infowindow = new google.maps.InfoWindow({
          content: $marker.html()
        });
        google.maps.event.addListener(marker, 'click', function () {
          infowindow.open(map, marker);
        });
      }
    }

    function center_map(map) {

      var bounds = new google.maps.LatLngBounds();
      $.each(map.markers, function (i, marker) {
        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
        bounds.extend(latlng);
      });

      if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter());
        map.setZoom(16);
      } else {
        map.fitBounds(bounds);
      }
    }

    var map = null;
    $(document).ready(function () {
      $('.acf-map').each(function () {
        map = new_map($(this));
      });
    });

  }
};



// WEBPACK FOOTER //
// ./scripts/routes/googlemaps.js